import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["m-f3 bg-gray-200 pl-f8 py-f5 cursor-pointer leading-10 text-center rounded-full", _ctx.isSelected ? 'bg-primary-default text-white' : 'hover:bg-primary-200'],
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click', _ctx.item.uuid)))
  }, _toDisplayString(_ctx.item.label), 3))
}